<template>
    <tr>
        <td align="center" v-if="tipo_periodo == 'V'">
            {{ recibo.DataVencimento | date("dd/LL/yyyy") }}
        </td>
        <td align="center" v-if="tipo_periodo == 'P'">
            {{ recibo.DataPagamento | date("dd/LL/yyyy") }}
        </td>
        <td>
            <download-link
                :href="url"
                target="_system"
                class="default-button full icon"
                v-if="recibo.CodReciboPai"
                >Demonstrativo [PDF]
                <i class="mdi mdi-cloud-download-outline"></i
            ></download-link>
        </td>
        <td v-if="agrupamento == 'Competência'">
            <span v-if="imovel">
                {{ imovel.Endereco }}
            </span>
            <span v-else>
                {{ recibo.Imovel }}
            </span>
        </td>
        <td v-if="agrupamento == 'Imóvel'" align="center">
            {{ recibo.Competencia }}
        </td>
        <td align="center">{{ recibo.Status }}</td>
        <td align="right">
            {{ recibo.Valor | number_format }}
        </td>
    </tr>
</template>
<script>
import { api_endpoint } from '~/plugins/api';

export default {
    props: ["recibo", "agrupamento", "tipo_periodo", "propriedades"],
    filters: {
        number_format(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "decimal",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);
        },
    },
    computed: {
        imoveis() {
            return this.propriedades;
        },
        imovel() {
            return this.imoveis.find(
                ({ subcodigo }) => subcodigo == this.recibo.Imovel
            );
        },
        jwt() {
            return this.$store.state.jwt;
        },
        url() {
            //let endpoint = `${location.origin}${location.pathname}api`;
            let endpoint = api_endpoint
            if (location.origin == "file://" || 'undefined' != typeof window.cordova) {
                endpoint = window.api_endpoint;
            }
            return `${endpoint}/aluguel/recibos/${this.recibo.CodReciboPai}/download?jwt=${this.jwt}`;
        },
    },
};
</script>